import { useState } from "react"
import PapripactGenerateModal from "@/entities/document/ui/modal/PapripactGenerateModal"
import Button from "@/components/button"
import PageHeader from "@/components/page-header"
import CalendarFilterPanel from "@/entities/prevention-action/ui/CalendarFilterPanel"
import PreventionActionsCalendar from "@/entities/prevention-action/ui/PreventionActionsCalendar"
import NavPrevention from "@/nav/nav.prevention"

export default function RisksCalendarRoute() {
  const [isGenerationOpen, setIsGenerationOpen] = useState(false)

  return (
    <NavPrevention>
      <div className="fixed left-0 top-[48px] flex h-[calc(100%-48px)] app-content-width">
        <CalendarFilterPanel />
        <div className="flex min-w-0 flex-1 flex-col overflow-hidden px-40 pt-20">
          <div className="overview-header">
            <PageHeader
              section="Prévention"
              title="Calendrier"
              subtitle="Visualisez les mesures de préventions prévues pour les prochains mois.">
              <div className="min-w-[20px]" />
              <Button isFullWidth isWithBorder className="secondary" onClick={() => setIsGenerationOpen(true)}>
                Créer le PAPRIPACT
              </Button>
            </PageHeader>
          </div>
          <PreventionActionsCalendar />
        </div>
      </div>
      {isGenerationOpen && <PapripactGenerateModal onClose={() => setIsGenerationOpen(false)} />}
    </NavPrevention>
  )
}
